<div class="modal modal__opened">
  <ng-container *ngIf="!smsSent else smsCodeInputBlock">
    <div class="modal__close icon icon-close" (click)="close()"></div>
    <div class="modal__container">
      <div class="modal__title h2">{{ 'auth-modal.title' | translate }}</div>
      <div class="modal__content">
        <div class="modal__form-field">
          <div class="input input_width_auto" [class.input_type_error]="msisdnError?.length > 0">
            <label class="input__label">{{ 'auth-modal.msisdn' | translate }}</label>
            <div class="input__container">
              <input type="text" [placeholder]="'auth-modal.msisdn-placeholder' | translate"
                     class="input__input"
                     inputmode="numeric"
                     [(ngModel)]="msisdn"
                     mask="+0 000 000-00-00"
                     [dropSpecialCharacters]="true"
                     [clearIfNotMatch]="false"
                     (keydown.backspace)="onBackspace($event)"
                     (ngModelChange)="msisdnChanged()"
                     (keyup.enter)="sendSms()"
                     (keyup.shift.enter)="sendSms()"
                     (paste)="onPaste($event)"/>
            </div>
          </div>
          <div class="input__error" *ngIf="msisdnError?.length > 0">{{ msisdnError | translate }}</div>
        </div>
      </div>
      <div class="modal__buttons">
        <div class="button button_width_full" [class.button_type_load]="smsRequestInProgress" [class.with-icon]="smsRequestInProgress" (click)="sendSms()">
          {{ 'auth-modal.login' | translate }}
        </div>
      </div>
      <div class="modal__subtext" [innerHtml]="'auth-modal.offer-text' | translate:{ appUrl: appUrl }"></div>
    </div>
  </ng-container>
</div>

<ng-template #smsCodeInputBlock>
  <div class="modal__backlink with-icon" (click)="backToMsisdn()">{{ 'auth-modal.back' | translate }}</div>
  <div class="modal__close icon icon-close" (click)="close()"></div>
  <div class="modal__container">
    <div class="modal__title modal__title-mb16 h2">{{ 'auth-modal.enter-sms-code' | translate }}</div>
    <div class="modal__subtitle">{{ 'auth-modal.sms-sent-to-msisdn' | translate:{msisdn: msisdn | mask: '+0 000 000-00-00'} }}</div>
    <div class="modal__content">
      <div class="modal__form-field">
        <div class="code-input" [class.code-input_status_error]="codeError?.length > 0" [class.code-input_status_disabled]="loginRequestInProgress"
             [class.code-input_status_filled]="code?.length == 4">
          <div class="code-input__inputs" #codeInputsBlock>
            <input type="text" inputmode="numeric" mask="0" class="code-input__input" [(ngModel)]="codeNumbers[0]" (ngModelChange)="codeChanged()"
                   (keyup.enter)="login()" (keyup.shift.enter)="login()" (keyup.arrowLeft)="moveLeft()" (keyup.arrowRight)="moveRight()" (keydown)="keydown($event)"
                   (paste)="pasteCode($event)"/>
            <input type="text" inputmode="numeric" mask="0" class="code-input__input" [(ngModel)]="codeNumbers[1]" (ngModelChange)="codeChanged()"
                   (keyup.enter)="login()" (keyup.shift.enter)="login()" (keyup.arrowLeft)="moveLeft()" (keyup.arrowRight)="moveRight()" (keydown)="keydown($event)"
                   (paste)="pasteCode($event)"/>
            <input type="text" inputmode="numeric" mask="0" class="code-input__input" [(ngModel)]="codeNumbers[2]" (ngModelChange)="codeChanged()"
                   (keyup.enter)="login()" (keyup.shift.enter)="login()" (keyup.arrowLeft)="moveLeft()" (keyup.arrowRight)="moveRight()" (keydown)="keydown($event)"
                   (paste)="pasteCode($event)"/>
            <input type="text" inputmode="numeric" mask="0" class="code-input__input" [(ngModel)]="codeNumbers[3]" (ngModelChange)="codeChanged()"
                   (keyup.enter)="login()" (keyup.shift.enter)="login()" (keyup.arrowLeft)="moveLeft()" (keyup.arrowRight)="moveRight()" (keydown)="keydown($event)"
                   (paste)="pasteCode($event)"/>
          </div>
          <div class="code-input__error" [class.code-input_status_error]="codeError?.length > 0">{{ codeError | translate }}</div>
        </div>
      </div>
    </div>
    <div class="modal__subtext modal__retry" *ngIf="smsTimout > 0">{{ 'auth-modal.sms-timout' | translate:{time: getTimeToSms()} }}</div>
    <div class="modal__subtext modal__retry" *ngIf="smsTimout == 0">
      <span class="modal__retry-link" (click)="sendSms()">{{ 'auth-modal.sms-retry' | translate }}</span>
    </div>
  </div>
</ng-template>
